import {
  PlacementDeepLinkClick,
  PlacementFallbackClick,
  PlacementLinkClick,
} from "./analyticsLib093IssuesEvents";
import { trackEvent } from "@adsk/acc-issues-core/utils/analytics/trackEvent";

export const trackPlacementLinkClick = (
  params: ConstructorParameters<typeof PlacementLinkClick>[0]
) => {
  trackEvent(new PlacementLinkClick(params));
};

export const trackPlacementDeepLinkClick = (
  params: ConstructorParameters<typeof PlacementDeepLinkClick>[0]
) => {
  trackEvent(new PlacementDeepLinkClick(params));
};

export const trackPlacementFallbackClick = (
  params: ConstructorParameters<typeof PlacementFallbackClick>[0]
) => {
  trackEvent(new PlacementFallbackClick(params));
};
